export default __webpack_public_path__ + "static/media/vanSelected.de9745e8.svg";